import { render } from "./MainHealthClubSlider.vue?vue&type=template&id=103c91b6&scoped=true"
import script from "./MainHealthClubSlider.vue?vue&type=script&lang=js"
export * from "./MainHealthClubSlider.vue?vue&type=script&lang=js"

import "./MainHealthClubSlider.vue?vue&type=style&index=0&id=103c91b6&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103c91b6"]])

export default __exports__